import { useEffect, useState } from "react";

import FarmerProgressBarChart from "features/onboarding/users/farmer/FarmerProgressBarChart";
import FarmerReportGaugeChart from "features/onboarding/users/farmer/FarmerReportGaugeChart";
import { Badge, Card, Spinner } from "react-bootstrap";

import { skipToken } from "@reduxjs/toolkit/query";
import { API_URL } from "app/config";
import { store } from "app/store";
import axios from "axios";
import FarmerCropHealthMap from "features/onboarding/users/farmer/FarmerCropHealthMap";
import { CardBody, CardHeader, Table } from "reactstrap";

import { Visibility } from "@mui/icons-material";
import { useGetSoilParametersQuery } from "features/dashboard/RiskManagement/RiskManagementApiSlice";
import { AdvisoryTextComponent } from "../AdvisoryTextComponent";
import RadialSoilScoreChart from "../RadialSoilScoreChart";
import { Link } from "react-router-dom";

export const SHRIProject = ({ orgId, AdvisoryUrl, projectId }) => {
  const [pagination, setPagination] = useState({ page: 1, per_page: 50 });
  const [selectedFarmer, setSelectedFarmer] = useState(null);
  const [SoilDetails, setSoilDetails] = useState([]);
  const [FarmerData, setFarmerData] = useState(null);
  const [loading, setIsLoading] = useState(false);
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [searchKey, setSearchKey] = useState("");
  const [StaticFarmers, setStaticFarmers] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);

  const { data: soilData, isLoading: soilLoading } = useGetSoilParametersQuery(
    selectedFarmer?.id ? { FarmerId: selectedFarmer.id } : skipToken
  );

  const nilokheriFarmers = [
    {
      id: "3660025d-454c-437c-a5a4-ac87362d7b26",
      farmer_name: "Rajpal Ji",
      phone_no: "9253182665",
    },
    {
      id: "47aa95e8-f71c-4cce-850b-82e348947adb",
      farmer_name: "Sunil Kumar",
      phone_no: "9050861154",
    },
    {
      id: "d5bdd11c-5431-4e8f-99e0-0a72c307c4a5",
      farmer_name: "Hari Kisan",
      phone_no: "9813901798",
    },
    {
      id: "8d09dcba-681a-4670-aed4-3f7fa09da508",
      farmer_name: "Rakhi Saini",
      phone_no: "9050906025",
    },
    {
      id: "a40035b2-ac41-4ede-8885-541e9dc68c4b",
      farmer_name: "Vikram Sharma",
      phone_no: "9812730003",
    },
    {
      id: "a6bd24d3-edda-4f1f-9dc0-565dd3feae52",
      farmer_name: "Vinod Kashyap",
      phone_no: "8816986432",
    },
    {
      id: "218ab37a-e463-4fb9-b176-d3830a16a14e",
      farmer_name: "Rinku Pal",
      phone_no: "9896836259",
    },
    {
      id: "986fff3c-f0af-43bf-8ea0-9fe9a8f3448d",
      farmer_name: "Sahil Saini",
      phone_no: "7404762214",
    },
  ];

  const hfpclFarmers = [
    {
      id: "127e8002-836e-45b0-9fdb-32464dd698f4",
      farmer_name: "Dhan Singh",
      phone_no: "9541633251",
    },
    {
      id: "54ed3c30-e0ca-4522-9dba-d6411d7c67b2",
      farmer_name: "Kehar Singh",
      phone_no: "9416044055",
    },
    {
      id: "64f6c067-74fd-4c38-a1dc-03b88c9fbe96",
      farmer_name: "Subas Chand",
      phone_no: "9996415650",
    },
    {
      id: "1700c99a-ae65-4101-8a42-80e99988026f",
      farmer_name: "Surendra Kumar",
      phone_no: "9416172299",
    },
    {
      id: "5ca189e8-8477-4c59-83e5-ef323ae2e8e5",
      farmer_name: "Nisan Singh",
      phone_no: "9466217625",
    },
    {
      id: "b639a4c9-b19d-4092-9df9-813d6fc79169",
      farmer_name: "Vijay Kumar",
      phone_no: "9466789028",
    },
    {
      id: "65555003-2d23-4e99-a3b1-e56ceac93c2b",
      farmer_name: "Gaurav",
      phone_no: "9896907277",
    },
    {
      id: "7f600f2f-1c3b-46f8-a4e5-eb6ac4f569eb",
      farmer_name: "Parveen Kumar",
      phone_no: "9996195800",
    },
    {
      id: "997d2666-fe96-4b8d-9642-272be89f70e8",
      farmer_name: "Jitendra Kumar",
      phone_no: "9991965230",
    },
    {
      id: "58193e81-6fe4-4df7-a2d8-493535fb1117",
      farmer_name: "Balvindher Singh",
      phone_no: "9416345501",
    },
    {
      id: "9bc91c00-a2e2-4e57-a437-f4204332cdaf",
      farmer_name: "Jaswinder Kumar",
      phone_no: "9050035441",
    },
    {
      id: "5f87ad0d-a7eb-4087-be36-912a9401c298",
      farmer_name: "Jasbir Singh",
      phone_no: "9812425237",
    },
    {
      id: "6101c0f2-0ab3-43bd-a037-b918d546df9d",
      farmer_name: "Mohit Mann",
      phone_no: "9306714097",
    },
    {
      id: "d3f2d4dc-ae99-4b63-a55e-fac95a09d05b",
      farmer_name: "Dalbir Singh",
      phone_no: "9466579439",
    },
  ];

  useEffect(() => {
    if (
      orgId === "c31e207c-2474-4dbf-9230-4c33fc7c433e" ||
      projectId === "c31e207c-2474-4dbf-9230-4c33fc7c433e"
    ) {
      setStaticFarmers(nilokheriFarmers);
    } else if (
      orgId === "d986ef06-1cb6-4615-b853-e6874e40cd71" ||
      projectId === "d986ef06-1cb6-4615-b853-e6874e40cd71"
    ) {
      setStaticFarmers(hfpclFarmers);
    } else {
      setStaticFarmers(null);
    }
  }, [orgId]);

  useEffect(() => {
    if (StaticFarmers?.length && !selectedFarmer) {
      handleSelectFarmer(StaticFarmers[0]);
    }
  }, [StaticFarmers]);

  const filteredFarmers = StaticFarmers.filter((farmer) =>
    farmer.farmer_name.toLowerCase().includes(debouncedSearch.toLowerCase())
  );

  useEffect(() => {
    setSoilDetails(soilData?.data?.results || []);
  }, [soilData]);

  const handleSelectFarmer = async (farmer) => {
    setSelectedFarmer(farmer);
    await fetchFarmerData(farmer.id);
  };

  const fetchFarmerData = async (farmerId) => {
    setIsLoading(true);
    const state = store.getState();
    try {
      const response = await axios.get(
        `${API_URL}/api/v1/onboarding/farmers/${farmerId}`,
        {
          headers: {
            Authorization: `Bearer ${state.auth.accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      setFarmerData(response?.data?.data?.farm);
    } catch (error) {
      console.error("Error fetching farmer data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  console.log(FarmerData, "farmerData");

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchKey.trim() ? searchKey : "");
    }, 500);

    return () => clearTimeout(handler);
  }, [searchKey]);

  const handleChangeSearch = (e) => {
    const value = e.target.value;
    setPagination({ page: 1, pageCount: 0, per_page: 50 });
    setSearchKey(value);
    setFarmerData("");
  };
  const getStaticAdvisory = (acs) => {
    if (acs >= 80) {
      return "Crop Health seems Very Good, No Actions are Required.";
    } else if (acs >= 70) {
      return "Crop Health seems Good but Needs to Keep Monitoring. If there is any aberration observed on the field, it can be intimated.";
    } else if (acs >= 60) {
      return "Crop Health is Good but there is a possibility of Stress so continuous monitoring is suggested.";
    } else if (acs >= 50) {
      return "Crop Health is Just fine, there is a possibility of Stress. Immediate field check is suggested.";
    } else {
      return "Crop Health is Poor, there is immediate intervention required in the context of nutrient and moisture management.";
    }
  };

  return (
    <div className="p-2">
      <div className="d-flex flex-lg-row flex-column align-items-start gap-3">
        <div
          className="col-lg-3 col-12"
          style={{
            borderRight: "1px solid #e5e5e5",
            padding: "15px",
            backgroundColor: "#f9f9f9",
            height: "auto",
            flexShrink: 0,
          }}
        >
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="mb-0">Farmers</h5>
            <div style={{ width: "60%" }}>
              <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Search farmers..."
                style={{
                  borderRadius: "8px",
                  padding: "8px 12px",
                  border: "1px solid #ced4da",
                  fontSize: "14px",
                }}
                onChange={handleChangeSearch}
              />
            </div>
          </div>

          {false ? (
            <div className="text-center p-4">
              <Spinner animation="border" />
              <p className="mt-2">Loading farmers...</p>
            </div>
          ) : (
            <>
              {filteredFarmers?.map((farmer) => (
                <div
                  key={farmer.id}
                  onClick={() => handleSelectFarmer(farmer)}
                  className={`d-flex align-items-center mb-3 p-2 rounded shadow-sm ${
                    selectedFarmer?.id === farmer.id
                      ? "bg-primary text-white"
                      : "bg-white"
                  }`}
                  style={{ cursor: "pointer", transition: "0.3s" }}
                >
                  <img
                    src={
                      farmer.ImageFile ||
                      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSxTYFlL3rMQGJUnGYA--ilSNhGJwCOdYr7kA&s"
                    }
                    alt={farmer.full_name}
                    className="rounded-circle me-3"
                    style={{
                      width: "50px",
                      height: "50px",
                      objectFit: "cover",
                    }}
                  />
                  <div>
                    <div className="fw-bold">{farmer.farmer_name}</div>
                    <small>{farmer.phone_no}</small>
                  </div>
                </div>
              ))}
            </>
          )}

          {/* Pagination */}
          {/* <div className="d-flex justify-content-between mt-4">
            <Button
              variant="secondary"
              size="sm"
              onClick={() =>
                setPagination((prev) => ({
                  ...prev,
                  page: Math.max(prev.page - 1, 1),
                }))
              }
              disabled={pagination.page === 1}
            >
              Previous
            </Button>
            <span>Page {pagination.page}</span>
            <Button
              size="sm"
              style={{
                backgroundColor:
                  farmerData?.data?.results?.length < pagination.per_page
                    ? "#6c757d"
                    : "#ff7f50",
                borderColor:
                  farmerData?.data?.results?.length < pagination.per_page
                    ? "#6c757d"
                    : "#ff7f50",
              }}
              onClick={() =>
                setPagination((prev) => ({ ...prev, page: prev.page + 1 }))
              }
              disabled={farmerData?.data?.results?.length < pagination.per_page}
            >
              Next
            </Button>
          </div> */}
        </div>

        <div className="col-lg-9 col-12">
          <Card className="shadow-sm mb-4">
            <Card.Header className="d-flex justify-content-between align-items-center">
              <h5 className="mb-0">
                {selectedFarmer?.farmer_name} - Farm Details
              </h5>

              <Link
                to={`/farmerDetail/onboarding/${selectedFarmer?.id}`}
                style={{ textDecoration: "none" }}
              >
                <span
                  className="text-primary d-flex align-items-center "
                  style={{ cursor: "pointer", fontSize: "14px" }}
                >
                  <Visibility fontSize="small" className="me-1" />
                  View Summary
                </span>
              </Link>
            </Card.Header>

            <Card.Body className="p-lg-4 p-1">
              {loading ? (
                <div className="text-center p-5">
                  <Spinner animation="border" />
                  <p className="mt-2">Loading farm data...</p>
                </div>
              ) : FarmerData?.length ? (
                FarmerData.map((farm, idx) => {
                  const relatedSoilParams = SoilDetails.filter(
                    (plot) => plot.PlotId === farm.id
                  );
                  return (
                    <div
                      key={idx}
                      className="mb-4 p-3 border rounded shadow-sm"
                    >
                      <h5 className="mb-3 text-primary">
                        Farm {idx + 1} - {farm?.plot_name || farm.land_mark}
                      </h5>

                      <div className="row mt-4 ">
                        <div className="col-lg-8 col-12">
                          <div className="d-flex align-items-center gap-2">
                            <i className="mdi mdi-home-analytics fs-5 text-success"></i>
                            <h5 className="m-0 fw-semibold text-dark">
                              Farm Details
                            </h5>
                          </div>

                          <div className="d-lg-block d-md-block d-none">
                            <Table className="table mb-0" hover responsive>
                              <tbody>
                                <tr>
                                  <th>Plot Name :</th>
                                  <td>{farm?.plot_name || "N/A"}</td>
                                  <th className="ps-4">Land Mark :</th>
                                  <td>{farm?.land_mark || "N/A"}</td>
                                </tr>
                                {/* <tr>
                                  <th>Survey Number :</th>
                                  <td>{farm?.survey_number || "N/A"}</td>
                                  <th className="ps-4">Declared Area:</th>
                                  <td>{farm?.declared_area || "N/A"}</td>
                                </tr> */}
                                <tr>
                                  <th>Calculated Area (in acres) :</th>
                                  <td>{farm?.calculated_area || "N/A"}</td>
                                  <th className="ps-4">Cropping Pattern :</th>
                                  <td>{farm?.cropping_pattern || "N/A"}</td>
                                  {/* <th>ACS:</th>
                                  <td>{farm?.ACS || "N/A"}</td> */}
                                </tr>
                                <tr>
                                  {/* <th>Crop Health:</th>
                                  <td>{farm?.crop_health || "N/A"}</td> */}
                                </tr>
                              </tbody>
                            </Table>
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <Card className="shadow-sm border-0">
                            <CardHeader
                              className="d-flex align-items-center gap-2 px-3 py-2"
                              style={{ background: "white" }}
                            >
                              <i className="mdi mdi-map fs-5 text-info"></i>
                              <h5 className="m-0 fw-semibold text-dark">
                                Farm Map
                              </h5>
                            </CardHeader>
                            <CardBody className="p-2">
                              <FarmerCropHealthMap
                                boundary={farm?.boundary}
                                acs={farm?.summary_stats?.acs}
                                height="30vh"
                                boundaryUpdated={farm.boundary_updated}
                                latLong={[
                                  farm?.central_latitude,
                                  farm?.central_longitude,
                                ]}
                              />
                            </CardBody>
                          </Card>
                        </div>
                      </div>

                      {relatedSoilParams?.length > 0 && (
                        <h5 className="m-0 fw-semibold text-dark mb-2 mx-2">
                          Soil Parameters
                        </h5>
                      )}
                      {relatedSoilParams?.length > 0
                        ? relatedSoilParams.map((plot, index) => (
                            <div
                              key={index}
                              className="mb-3 p-3 border rounded"
                              style={{ backgroundColor: "#eff0f3" }}
                            >
                              <h6>{plot.Parameters?.Time || "N/A"}</h6>
                              <div className="row g-3 mt-2">
                                <div className="col-md-3">
                                  <div className="border rounded p-2 text-center bg-white">
                                    <small className="text-muted">
                                      Moisture
                                    </small>
                                    <h5 className="mt-1 text-primary">
                                      {plot.Parameters?.moisture || "N/A"}%
                                    </h5>
                                  </div>
                                </div>
                                <div className="col-md-3">
                                  <div className="border rounded p-2 text-center bg-white">
                                    <small className="text-muted">
                                      Temperature
                                    </small>
                                    <h5 className="mt-1 text-danger">
                                      {plot.Parameters?.temperature || "N/A"}°C
                                    </h5>
                                  </div>
                                </div>
                                <div className="col-md-3">
                                  <div className="border rounded p-2 text-center bg-white">
                                    <small className="text-muted">
                                      EC Value
                                    </small>
                                    <h5 className="mt-1 text-success">
                                      {plot.Parameters?.ecValue || "N/A"}
                                    </h5>
                                  </div>
                                </div>
                                <div className="col-md-3">
                                  <div className="border rounded p-2 text-center bg-white">
                                    <small className="text-muted">
                                      PH Value
                                    </small>
                                    <h5 className="mt-1 text-success">
                                      {plot.Parameters?.pHValue || "N/A"}
                                    </h5>
                                  </div>
                                </div>
                              </div>

                              {/* NPK */}
                              <div className="mt-3 d-flex justify-content-center gap-2">
                                <Badge bg="primary">
                                  N : {plot.Parameters?.nValue || "N/A"}
                                </Badge>
                                <Badge bg="success">
                                  P : {plot.Parameters?.pValue || "N/A"}
                                </Badge>
                                <Badge bg="warning" text="dark">
                                  K : {plot.Parameters?.kValue || "N/A"}
                                </Badge>
                              </div>
                            </div>
                          ))
                        : ""}

                      <h6 className="mt-4 mb-2">Scores</h6>

                      <div className="row mt-2">
                        <div className="col-md-3 text-center">
                          <RadialSoilScoreChart
                            value={farm?.scores?.soul_score || "N/A"}
                            label="Soul Score"
                          />
                        </div>
                        {/* <div className="col-md-4 text-center">
                          
                          <FarmerReportGaugeChart
                            farmerDataCl={farm?.summary_stats?.acs}
                            chartName="Agriculture Credit Score"
                          />
                            </div> */}

                        <div className="col-md-5 text-center">
                          {(() => {
                            const latestACS =
                              Array.isArray(farm?.scores?.ACS) &&
                              farm?.scores?.ACS.length > 0 &&
                              typeof farm.scores.ACS[0] === "object"
                                ? Object.values(farm.scores.ACS[0])[0]
                                : 0;

                            return (
                              <FarmerReportGaugeChart
                                farmerDataCl={latestACS}
                                chartName="Agriculture Credit Score"
                              />
                            );
                          })()}
                        </div>

                        {/* <div className="col-md-4 text-center">
                          <FarmerProgressBarChart
                            farmerDataCl={farm?.summary_stats?.crop_health}
                            chartName="Crop Health Score"
                          />
                        </div> */}
                        <div className="col-md-3 text-center">
                          {(() => {
                            const latestHealth =
                              Array.isArray(farm?.scores?.crop_health) &&
                              farm?.scores?.crop_health.length > 0 &&
                              typeof farm.scores.crop_health[0] === "object"
                                ? Object.values(farm.scores.crop_health[0])[0]
                                : 0;

                            return (
                              <FarmerProgressBarChart
                                farmerDataCl={latestHealth}
                                chartName="Crop Health Score"
                              />
                            );
                          })()}
                        </div>
                      </div>
                      {/* <AdvisoryTextComponent
                        disclaimer={farm.scores?.disclaimer?.en}
                        advisory={farm?.scores?.advisory?.en}
                      ></AdvisoryTextComponent> */}
                      <AdvisoryTextComponent
                        disclaimer={farm.scores?.disclaimer?.en}
                        advisory={farm?.scores?.advisory?.en}
                        staticAdvisory={getStaticAdvisory(
                          Array.isArray(farm?.scores?.ACS) &&
                            farm.scores.ACS.length > 0 &&
                            typeof farm.scores.ACS[0] === "object"
                            ? Object.values(farm.scores.ACS[0])[0]
                            : 0
                        )}
                      />
                    </div>
                  );
                })
              ) : (
                <div className="text-muted text-center p-4">
                  No farm data available
                </div>
              )}
            </Card.Body>
          </Card>
        </div>
      </div>
    </div>
  );
};
